import { Body } from '../../components/Typography';
import { HFlex, VFlex } from '../../components/FlexContainers';
import { palette } from '../../theme/palette';
import { PrimaryButton } from '../../components/Buttons';
import { Skeleton, styled } from '@mui/material';
import { fontWeight } from '../../theme/typography';

export const Root = styled(HFlex)`
  align-items: center;
  gap: 40px;

  ${(props) => props.theme.breakpoints.down('md')} {
    flex-direction: column;
    gap: 21px;
  }
`;

export const CreateAccountButton = styled(PrimaryButton)`
  width: 243px;
  height: 52px;

  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
    height: 42px;
  }
`;

export const HaveAnAccount = styled(Body)`
  color: ${palette.custom.white};
  font-size: 14px;
  font-style: normal;
  font-weight: ${fontWeight.bold};
  line-height: normal;
  letter-spacing: 0.7px;
  text-transform: uppercase;
`;

export const SignInLink = styled(HaveAnAccount)`
  color: ${palette.primary.main};
  cursor: pointer;
`;

export const SkeletonContainer = styled(VFlex)`
  width: 100%;
  max-width: 400px;
  height: 52px;
  gap: 6px;
  justify-content: center;
  span:nth-child(2) {
    width: 80%;
  }
`;

export const SkeletonBar = styled(Skeleton)`
  background-color: rgb(255 255 255 / 11%);
  height: 15px;
`;
